import React, { useState } from "react";
import AdminAppBar from "../../../components/adminComponents/AdminAppBar";
import CustomHeading from "../../../components/common/CustomHeading";
import { useLocation, useNavigate } from "react-router-dom";
import PropertyProgress from "./PropertyProgress";
import PropertyQueries from "./PropertyQueries/PropertyQueries";
import InfoCallectionPage from "./PropertyStep/InfoCollectionAndAssignment/InfoCallectionPage";
import ConfirmedListPage from "./PropertyStep/ConfirmedListTBD/ConfirmedListPage";
import InSalesPage from "./PropertyStep/InSalesTBD/InSalesPage";
import LegalAnalysisPage from "./PropertyStep/LegalAnalysisTBD/LegalAnalysisPage";
import Header from "../../Header/Header";
import { ToastContainer } from "react-toastify";
import PresentationPreparationPage from "./PropertyStep/PresentationPreparation/PresentationPreparationPage";
import useScrollToTop from "../../../components/hooks/useScrollToTop";
import ConfirmationModal from "../../../components/shareableContainer/ConfirmationModal";

const PropertyInfoPage = () => {
  const location = useLocation();
  const { propertyName, propertyId  , propertyStage , propertyTypeName , selectedPropertyData} = location.state || {
    propertyName: "Property Name",
  };

  console.log("SelectedPropertyData", selectedPropertyData);
  const [currentStep, setCurrentStep] = useState(1);
  const [currentStage, setCurrentStage] = useState("");
  const [progressTrigger, setProgressTrigger] = useState(false);
  const navigate = useNavigate();

  useScrollToTop();

 let isDropped = currentStage === "Dropped";
 let isConfirmed = currentStage === "Confirmed List";

 

  return (
    <div className="bg-appGrayBackground min-h-screen pb-14">
      <Header />
     
      <div className="pt-28 px-6">
        <div className="flex items-center justify-between mb-5">
          <div className="">
<CustomHeading title={propertyName} isIcon={true} />
          </div>
          

          
        <div className="flex items-center gap-4">
           <button
           onClick={
              () => navigate("/presentation-property/attachments-history", { 
                state: {
                  prospectPropertyId : propertyId,
                  propertyName : propertyName,
                }
               })
           }
           className="px-4 py-2 text-nowrap bg-white text-customGreen rounded-md ">
           View All Attachment
          </button>

           <button
                 onClick={() => {
          if(propertyTypeName && propertyTypeName === "Resale Plot") {
            navigate("/prospect/resale-plot", {  
              state: {
                propertyName: propertyName,
                propertyId: propertyId,
                propertyTypeName : propertyTypeName,
                propertyStage : propertyStage,
              },
            });
            return;
          }
          else if (propertyTypeName && propertyTypeName === "Acres and Cents") {
            navigate("/prospect/acres-and-cents", {
             state: {
                propertyName: propertyName,
                propertyId: propertyId,
                propertyTypeName : propertyTypeName,
                propertyStage : propertyStage,
              },
            });
            return;
          }else 
          navigate("/prospect/layout", {
           state: {
                propertyName: propertyName,
                propertyId: propertyId,
                propertyTypeName : propertyTypeName,
                propertyStage : propertyStage,
              },
          });
        }}
           className="px-4 py-2 text-nowrap bg-white text-customGreen rounded-md ">
           Prospect Info
          </button>
         
           <button
           className="px-4 py-2 text-nowrap bg-white text-customGreen rounded-md ">
           Prospect History
          </button>
          

         
        </div>
        </div>
        <PropertyProgress
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          propertyId={propertyId}
          setProgressTrigger={setProgressTrigger}
          progressTrigger={progressTrigger}
          setCurrentStage={setCurrentStage}
        />

        <div className="grid grid-cols-12 mt-[27px] gap-5 ">
          <div className="col-span-4">
            <PropertyQueries 
              propertyId={propertyId} 
              isDropped={isDropped} 
              setProgressTrigger={setProgressTrigger}
            />
          </div>

          <div className="col-span-8">
            {currentStep === 1 && (
              <InfoCallectionPage propertyId={propertyId} setCurrentStep={setCurrentStep} setProgressTrigger={setProgressTrigger} isDropped={isDropped} />
            )}

            {currentStep === 2 && <LegalAnalysisPage propertyId={propertyId} setCurrentStep={setCurrentStep} setProgressTrigger={setProgressTrigger}  isDropped={isDropped}/>}

            {currentStep === 3 && <PresentationPreparationPage  selectedPropertyData ={selectedPropertyData} setProgressTrigger={setProgressTrigger}  propertyId={propertyId} setCurrentStep={setCurrentStep}/>}

            {currentStep === 4 && <InSalesPage selectedPropertyData ={selectedPropertyData} propertyId={propertyId} setProgressTrigger={setProgressTrigger}  setCurrentStep={setCurrentStep} isConfirmed={isConfirmed} />}

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyInfoPage;
